// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import Tdg_AddressSchema from './tdg-address-schema';
import Tdg_ContactDetailsSchema from './tdg-contact-details-schema';
import Tdg_ProfessionSchema from './tdg-profession-schema';

const schema = {
  $id: '/tdg-company-detail-schema',
  type: 'object',
  required: ['id', 'creatorId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    companyName: {
      type: 'string',
      nullable: true,
    },
    companyAddress: {
      ...Tdg_AddressSchema,
    },
    companyContactDetails: {
      ...Tdg_ContactDetailsSchema,
    },
    companyLogo: {
      type: 'string',
      nullable: true,
    },
    companyProfession: {
      type: 'array',
      nullable: true,
      items: { ...Tdg_ProfessionSchema },
    },
    companyApprenticeshipsCount: {
      type: 'integer',
      nullable: true,
    },
    companyDescription: {
      type: 'string',
      nullable: true,
    },
    organisationName: {
      type: 'string',
      nullable: true,
    },
    organisationLogo: {
      type: 'string',
      nullable: true,
    },
    organisationContactDetails: {
      ...Tdg_ContactDetailsSchema,
    },
  },
} as IJSONSchema;

export default schema;
